// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'letter-solid';

export const Component = () => (
  <path d='M23.037 2H1.485c-.431 0-.766.144-1.054.431A1.408 1.408 0 0 0 0 3.485v16.667c0 .43.144.766.431 1.053.288.288.623.432 1.054.432h21.552c.431 0 .766-.144 1.054-.432.287-.287.43-.622.43-1.053V3.485a1.41 1.41 0 0 0-.43-1.054A1.408 1.408 0 0 0 23.037 2ZM4.407 13.781h6.896c.335 0 .479.144.479.48 0 .334-.144.526-.479.526H4.406c-.335 0-.479-.192-.479-.527s.144-.479.48-.479Zm9.817 3.928H4.406c-.335 0-.479-.144-.479-.48 0-.334.144-.478.48-.478h9.817c.335 0 .48.144.48.479 0 .335-.145.479-.48.479ZM21.6 5.927v3.928a.977.977 0 0 1-.288.718c-.239.192-.478.288-.718.288h-3.928a.946.946 0 0 1-.67-.288.976.976 0 0 1-.287-.718V5.927c0-.239.096-.479.287-.67a.946.946 0 0 1 .67-.287h3.928c.239 0 .479.096.718.287a.946.946 0 0 1 .288.67Z' />
);

export const viewBox = '0 0 25 25';
